import { render, staticRenderFns } from "./detailsNbc.vue?vue&type=template&id=2e8d27cb&scoped=true&"
import script from "./detailsNbc.vue?vue&type=script&lang=js&"
export * from "./detailsNbc.vue?vue&type=script&lang=js&"
import style0 from "./detailsNbc.vue?vue&type=style&index=0&id=2e8d27cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d27cb",
  null
  
)

component.options.__file = "detailsNbc.vue"
export default component.exports